"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createpseudonativemethod = _interopRequireDefault(require("./createpseudonativemethod"));

var _concat = _interopRequireDefault(require("./concat"));

var _keys = _interopRequireDefault(require("./keys"));

var _values = _interopRequireDefault(require("./values"));

var _entries = _interopRequireDefault(require("./entries"));

var splitBySpaceReg = /\s+/;
var methods = {
  concat: _concat["default"],
  keys: _keys["default"],
  values: _values["default"],
  entries: _entries["default"]
};
"push pop unshift shift sort reverse splice map filter slice every some reduce reduceRight\nforEach join indexOf lastIndexOf copyWithin fill includes find findIndex".split(splitBySpaceReg).forEach(function (name) {
  methods[name] = (0, _createpseudonativemethod["default"])(name);
});
'push pop unshift shift sort reverse splice copyWithin fill'.split(splitBySpaceReg).forEach(function (name) {
  methods["".concat(name, "_")] = (0, _createpseudonativemethod["default"])(name, true);
});
var _default = methods;
exports["default"] = _default;
//# sourceMappingURL=index.js.map